import { useQuery } from "@tanstack/react-query";
import axiosAPI from "../axiosAPI";

export const useLawsuitFinancialSummary = (lawsuitId) => {
  const enabled = Boolean(lawsuitId);

  const query = useQuery({
    queryKey: ["lawsuit-financial-summary", lawsuitId],
    enabled,
    queryFn: async () => {
      const { data } = await axiosAPI.get(
        `/lawsuits/${lawsuitId}/financial-summary`
      );
      return data;
    },
  });

  return {
    summary: query.data?.financial_summary ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.error,
    refetch: query.refetch,
  };
};
